import { usePropertiesViewModel } from "../../viewmodel/usePropertiesViewModel";
import { Step1 } from "../Step1";
import { Step2 } from "../Step2";
import { Step3 } from "../Step3";
import styles from "./addProperty.module.css";

/**
 * PropertiesPage Component
 * Page-level component that uses ViewModel
 */
export const AddProperty = () => {
  const {
    addressData,
    currentStep,
    formData,
    propertyDetails,
    handleNext,
    handleBack,
    handleStep2Next,
    handleStep3Next,
  } = usePropertiesViewModel();

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <Step1
            addressData={addressData}
            propertyDetails={propertyDetails}
            onNext={handleNext}
            onBack={handleBack}
          />
        );
      case 2:
        return (
          <Step2
            addressData={addressData}
            propertyDetails={propertyDetails}
            onNext={handleStep2Next}
            onBack={handleBack}
            formData={formData}
          />
        );
      case 3:
        return (
          <Step3
            addressData={addressData}
            propertyDetails={propertyDetails}
            onNext={handleStep3Next}
            onBack={handleBack}
            formData={formData}
          />
        );
      // case 4:
      //   return (
      //     <ReviewSteps
      //       addressData={addressData}
      //       formData={formData}
      //       onBack={handleBack}
      //       onSubmit={handleSubmit}
      //     />
      //   );
      default:
        return <Step1 addressData={addressData} onNext={handleNext} onBack={handleBack} />;
    }
  };

  return <div className={styles.stepperContainer}>{renderStep()}</div>;
};
// };

// return <div className={styles.stepperContainer}>{renderStep()}</div>;
// };
